module.exports = __webpack_public_path__ + "static/media/BricolageGrotesque-Medium.d43d9fda.woff2";